// Renders the [gallerij] shortcode output (see includes/legacy/shortcode_galerij.php).
// The shortcode emits a .gallery-wrapper with a base64-encoded JSON list of images in
// data-json; this module decodes it, renders the figures in batches and wires up the
// "load more" button. Fancybox is bound separately in main.js on [data-fancybox].
export function initGalleryImages() {
    const wrappers = document.querySelectorAll(".gallery-wrapper");

    wrappers.forEach((wrapper) => {
        // voorkom dubbel init (bijv. bij soft nav / re-render)
        if (wrapper.dataset.galleryInit === "1") return;
        wrapper.dataset.galleryInit = "1";

        const encoded = wrapper.dataset.json;
        if (!encoded) return;

        let images;
        try {
            // sommige WP filters vervangen + of voegen whitespace toe
            const clean = String(encoded).trim().replace(/\s+/g, "");
            images = JSON.parse(atob(clean));
            if (!Array.isArray(images)) throw new Error("Gallery JSON is not an array");
        } catch (err) {
            console.warn("Gallery decode/parse failed", err);
            // skeleton weg zodat je geen "hangende loader" hebt
            wrapper.querySelector(".gallery-skeleton")?.remove();
            return;
        }

        const id = wrapper.dataset.galleryId ?? wrapper.dataset.gallery ?? "0";
        const loadMoreCount = parseInt(wrapper.dataset.loadMore || "12", 10);

        let index = 0;

        // maak gallery container
        const gallery = document.createElement("div");
        gallery.classList.add("gallery");
        gallery.dataset.galleryId = id;

        if (wrapper.classList.contains("shuffle")) {
            gallery.classList.add("shuffle");
        }

        const fancyboxGroup = `gallery-${id}`;

        // zorg dat skeleton verdwijnt zodra we echt gaan renderen
        wrapper.querySelector(".gallery-skeleton")?.remove();

        // Load more knop container zodat hij ALTIJD onderaan blijft
        const controls = document.createElement("div");
        controls.className = "gallery-controls";

        let loadMoreBtn = null;

        const renderBatch = () => {
            const slice = images.slice(index, index + loadMoreCount);

            slice.forEach((img, i) => {
                const fig = document.createElement("figure");
                const alt = (img.caption && String(img.caption).trim()) || `Afbeelding ${index + i + 1}`;

                const enlarge = img.enlarge || img.medium || img.thumb;
                const thumb   = img.thumb || img.medium || img.enlarge;

                if (!enlarge || !thumb) {
                    console.warn("Gallery image skipped (no usable sizes)", img);
                    return;
                }

                fig.innerHTML = `
          <span data-src="${escapeAttr(enlarge)}"
                data-fancybox="${escapeAttr(fancyboxGroup)}"
                title="${escapeAttr(alt)}">
            <img src="${escapeAttr(thumb)}" loading="lazy" alt="${escapeAttr(alt)}">
            <i class="fa fa-search-plus" aria-hidden="true"></i>
          </span>
        `;

                gallery.appendChild(fig);

                // animatie "veilig"
                requestAnimationFrame(() => fig.classList.add("loaded"));
            });

            index += slice.length;

            if (index >= images.length && loadMoreBtn) {
                loadMoreBtn.remove();
                loadMoreBtn = null;
            }
        };

        // mount in juiste volgorde: gallery -> controls
        wrapper.appendChild(gallery);
        wrapper.appendChild(controls);

        renderBatch();

        // button aanmaken indien nodig
        if (images.length > loadMoreCount) {
            loadMoreBtn = document.createElement("button");
            loadMoreBtn.type = "button";
            loadMoreBtn.className = "gallery-load-more";
            loadMoreBtn.textContent = "Meer afbeeldingen laden";

            // SAFE click handler: blokkeer bubbling zodat injectors minder kans hebben
            loadMoreBtn.addEventListener(
                "click",
                (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

                    renderBatch();
                },
                { capture: true } // eerder dan de meeste document-level listeners
            );

            controls.appendChild(loadMoreBtn);
        }
    });
}

// minimal attribute escaping (voorkomt quotes / rare chars issues)
function escapeAttr(value) {
    return String(value)
        .replaceAll("&", "&amp;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;");
}
